import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { AuthContext } from "./AuthContext";
export const AuthProvider = ({ api, useSessionStore, children }) => {
    const [state, updateSessionState, clearState] = useSessionStore();
    const logout = useCallback(async () => {
        try {
            await api.post("/v5/session/logout");
        }
        catch {
            // empty catch
        }
        finally {
            clearState();
        }
    }, [clearState, api]);
    return (_jsx(AuthContext.Provider, { value: {
            sessionState: state,
            isLoggedIn: Boolean(state.userId && state.partnerId),
            logout,
            updateSessionState,
        }, children: children }));
};
